// extracted by mini-css-extract-plugin
module.exports = {"activityTotalsSection":"jgp-16w1N","box":"jgp-2nQ1K","summary":"jgp-1muul"};